


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyDo1aiy_yFSxOZpIM1Jg0Gu6Yl31v6Z8fc",
  authDomain: "aloka-spex-780e7.firebaseapp.com",
  projectId: "aloka-spex-780e7",
  storageBucket: "aloka-spex-780e7.firebasestorage.app",
  messagingSenderId: "421771917945",
  appId: "1:421771917945:web:6c048cb24602b79b87f2a8"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export